import { render, staticRenderFns } from "./SettingsChangePassword.vue?vue&type=template&id=1320bb49&scoped=true&"
import script from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./SettingsChangePassword.vue?vue&type=style&index=0&id=1320bb49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320bb49",
  null
  
)

export default component.exports